module.exports = __webpack_public_path__ + "static/media/CloudDisk_002.7a94bd73.png";